import React, { PropsWithChildren } from 'react';
import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { themeMediaQuery } from '../../utils/themeMediaQuery';
import { Box } from '../Box';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) =>
    !['drawerWidth', 'isDrawerOpen'].includes(String(prop)),
})<{ isDrawerOpen: boolean; drawerWidth: string }>`
  display: flex;
  position: fixed;
  background-color: ${({ theme }) => theme.palette.background.paper};
  bottom: 0;
  right: 0;
  width: 100%;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(2)};
  border-top: 1px solid ${({ theme }) => theme.palette.neutral[200]};
  z-index: 1;
  ${({ theme, isDrawerOpen, drawerWidth }) => themeMediaQuery(theme, 'sm')`
    max-width: 800px;
    padding: ${theme.spacing(Spacing.Medium)};
    margin-right: ${isDrawerOpen ? drawerWidth : 'unset'};
    transition:
    margin-right 0.2s ease,
    max-width 0.2s ease,
    padding 0.2s ease;
  `}
`;

interface FooterFixedProps {
  readonly 'data-testid'?: string;
  readonly isDrawerOpen?: boolean;
  readonly drawerWidth?: string;
}

export function FooterFixed({
  children,
  isDrawerOpen = false,
  drawerWidth = '600px',
  'data-testid': dataTestId,
}: PropsWithChildren<FooterFixedProps>) {
  return (
    <StyledBox
      data-testid={dataTestId}
      drawerWidth={drawerWidth}
      isDrawerOpen={isDrawerOpen}
    >
      {children}
    </StyledBox>
  );
}
